import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = l((o, a) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: a,
    ...o,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6 1H4v2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2V1h-2v2H6zm7 4H3v2h10z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
n.displayName = "CalendarIcon";
export {
  n as CalendarIcon,
  n as default
};
//# sourceMappingURL=index.js.map
